import { AbstractType } from 'src/lib/types/models/AbstractType'

// abstract class
export class ModelType extends AbstractType {}



// WEBPACK FOOTER //
// ./src/lib/types/models/ModelType.js